<template>
    <div>
        <div class="mb-3 d-flex">
            <v-divider class="border-opacity-100" vertical :thickness="4" :color="$system.systemSettings.knowledge_base_color"></v-divider>
            <h4 class="mb-1 ms-2">{{ categoryName }}</h4>
        </div>
        <div class="text-meta mb-3" v-if="categoryDescription">{{ categoryDescription }}</div>
        <div v-if="articleCategoryList.length">
            <div class="d-flex align-center mb-3 pa-4 border cursor-pointer rounded" v-for="item in articleCategoryList" @click="$router.push({ path: `/kb/articles/${item.id}/${item.slug}` }); searchDialog = false;">
                <v-icon size="21" class="me-2" color="grey-darken-1">icon-filekb</v-icon>
                <p class="text-meta text-grey-darken-3 flex-grow-1">{{ item.name }}</p>
                <v-divider class="mx-2 border-opacity-50" vertical></v-divider>
                <v-icon v-if="item.read_time" class="me-2" color="grey-darken-1" size="16">icon-timekb</v-icon>
                <p v-if="item.read_time" class="text-small text-grey-darken-2">{{ item.read_time }} دقیقه</p>
            </div>
            <v-pagination
                v-if="totalPages > 1"
                class="kb-pagination mt-7"
                :length="totalPages"
                :total-visible="7"
                @update:modelValue="getList"
                color="secondary"
            ></v-pagination>
        </div>
        <div v-else class="text-center font-weight-medium mt-15 text-grey-darken-2 user-select-none">موردی پیدا نشد!</div>
    </div>
</template>
<script>
export default {
    layout:"kb",
    auth: false,
    validate(context) {
        return context.system.systemSettings.kb_core && context.system.systemSettings.knowledge_base_status;
    },
    title:'دسته‌بندی',
    data() {
        return {
            articleCategoryList:[],
            totalPages: 1,
            page: 1,
        }
    },
    computed: {
        categoryName: function () {
            return this.$system.kbCategories.concat(this.$system.kbCategories.map(x => x.children).flat()).find(x=> x.id == this.$route.params.id)?.name ?? '';
        },
        categoryDescription: function () {
            return this.$system.kbCategories.concat(this.$system.kbCategories.map(x => x.children).flat()).find(x=> x.id == this.$route.params.id)?.description ?? '';
        },
    },
    methods: {
        async getList(value){
            this.$loading.start();
            await this.$kbArticleList({category_id: this.$route.params.id, page: value}).then(res=>{
                if(res && res.status == "OK"){
                    this.articleCategoryList = res.data;
                    this.totalPages = res.totalPages;
                }
            }).finally(()=>{ this.$loading.finish() })
        }
    },
    watch: {
        '$route'() {
            this.getList();
        }
    },
    created() {
        this.$loading.start();
        Promise.all([
            this.$system.setKbCategories(),
            this.getList()
        ]).finally(() => this.$loading.finish())
    },
}
</script>
